<template>
	 <div>
     <div class="wrap" v-if="isMobile">
		  <div class="mbaomingInfo">
			    <h2>我的报名信息</h2>
				<template v-if="hasData"> 
					<div class="list" v-for="item in noticeArr" v-bind:key="item.ID">
						<template v-if="checkStatus(item.limit_time)!=0">
						<ul>
							<li>报名等级：{{item.Title}}</li>
							<li>报名时间：{{formatDate(item.CreateDate)}}</li>
							<li>报名费用：{{item.Bal}}元</li>
							<li>笔试剩余：{{item.WrittenTestCount}}次</li>
							<li>实操剩余：{{item.OperationCount}}次</li>
							<li class="last" v-if="checkStatus(item.limit_time)==1"><div class="grid-content bg-purple">
								<span @click="showWindow(item.Bal,item.ID,item.GameID,item.Title)" class="pay">{{item.limit_time}}</span></div></li>
							<li class="last" v-else-if="checkStatus(item.limit_time)==8"><div class="grid-content bg-purple"><router-link to="/auth" class="pay">{{item.limit_time}}</router-link></div></li>	
							<li class="last" v-else-if="checkStatus(item.limit_time)==2"><div class="grid-content bg-purple"><router-link to="/exam-result" class="pay">{{item.limit_time}}</router-link></div></li>	
							<li class="last" v-else-if="checkStatus(item.limit_time)==3"><div class="grid-content bg-purple"><router-link to="/operation" class="pay">{{item.limit_time}}</router-link></div></li>	
							<li class="last" v-else-if="checkStatus(item.limit_time)==4"><div class="grid-content bg-purple"><router-link to="/address" class="pay">{{item.limit_time}}</router-link></div></li>	
							<li class="last1" v-else><div class="grid-content bg-purple"><span>当前进度：{{item.limit_time}}</span></div></li>	
						</ul>
						</template>
					</div>
				</template>
				<template v-else>
					<p><img class="vam" src="../assets/baoming.png" width="180"><span>暂无报名信息</span></p>
					<router-link class="baoming-btn" to="/sign-up">去报名</router-link>
				</template>
		  </div>
     </div>
	 <div v-else>
	 <div class="content" v-if="isShow">
        <div class="baomingInfo">
			<h2>我的报名信息</h2>
			<ul v-if="realName"><li>考生姓名：<span>{{realName}}</span></li><li>证件号码：<span>{{idcard}}</span></li></ul>
			<div class="clear"></div>

			<template v-if="hasData"> 
				<div class="list">
					<el-row class="item item-th"  >
						<el-col :span="7"><div class="grid-content bg-purple">报名类型</div></el-col>
						<el-col :span="4"><div class="grid-content bg-purple">报名时间</div></el-col>
						<el-col :span="3"><div class="grid-content bg-purple">报名费(元)</div></el-col>
						<el-col :span="3"><div class="grid-content bg-purple">笔试剩余次数</div></el-col>
						<el-col :span="3"><div class="grid-content bg-purple">实操剩余次数</div></el-col>
						<el-col :span="4"><div class="grid-content bg-purple">当前状态</div></el-col>
					</el-row>
					
					<el-row class="item item-td" v-for="item in noticeArr" v-bind:key="item.ID" >
						<el-col :span="7"><div class="grid-content bg-purple">{{item.Title}}</div></el-col>
						<el-col :span="4"><div class="grid-content bg-purple">{{formatDate(item.CreateDate)}}</div></el-col>
						<el-col :span="3"><div class="grid-content bg-purple">{{item.Bal}}</div></el-col>
						<el-col :span="3"><div class="grid-content bg-purple">{{item.WrittenTestCount}}</div></el-col>
						<el-col :span="3"><div class="grid-content bg-purple">{{item.OperationCount}}</div></el-col>
						
						<template v-if="checkStatus(item.limit_time)==0">
							<el-col :span="4"><div class="grid-content bg-purple"><span >{{item.limit_time}}</span></div></el-col>
						</template>	
						<template v-else-if="checkStatus(item.limit_time)==1"> 
							<el-col :span="4">
								<div class="grid-content bg-purple">
									<span @click="showWindow(item.Bal,item.ID,item.GameID,item.Title)" class="pay">{{item.limit_time}}</span>
									<!-- &nbsp;&nbsp;<span @click="baomingCancel(item.ID)" class="pay">取消</span> -->
								</div>
							</el-col>
						</template>
						<template v-else-if="checkStatus(item.limit_time)==8">
								<el-col :span="4"><div class="grid-content bg-purple"><router-link to="/auth" class="pay">{{item.limit_time}}</router-link></div></el-col>
						</template>
						<template v-else-if="checkStatus(item.limit_time)==2">
								<el-col :span="4"><div class="grid-content bg-purple"><router-link to="/exam-result" class="pay">{{item.limit_time}}</router-link></div></el-col>
						</template>
						<template v-else-if="checkStatus(item.limit_time)==3">
								<el-col :span="4"><div class="grid-content bg-purple"><router-link to="/operation" class="pay">{{item.limit_time}}</router-link></div></el-col>
						</template>
						<template v-else-if="checkStatus(item.limit_time)==4">
							<el-col :span="4"><div class="grid-content bg-purple"><router-link to="/address" class="pay">{{item.limit_time}}</router-link></div></el-col>
						</template>
						<template v-else>
							<el-col :span="4"><div class="grid-content bg-purple"><span>{{item.limit_time}}</span></div></el-col>
						</template>	
					</el-row>
				</div>

				<div class="pagination fr">
					<el-pagination background layout="prev, pager, next , jumper" :hide-on-single-page="true" :pager-count=5 :total="totalCount" :page-size="pageSize" :current-page="pageIndex" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</template>
			<template v-else>
				<p><img class="vam" src="../assets/baoming.png" width="180"><span>暂无报名信息</span></p>
				<router-link class="baoming-btn" to="/sign-up">去报名</router-link>
			</template>
        </div>

		
	</div>
	</div>
	 	<!-- 支付 -->
		<pay :Bal="bal" :GameID="gameId" :Game="levelGame" :ID="id" :IsMySignUpPage="IsMySignUpPage" :isShow="isShowWindow" @on-close="closeWindow" @on-reload="reload"></pay>
	</div>
</template>
<style scoped>
.baomingInfo { margin:16px 0;  background:#fff;overflow: hidden; font-size:14px; }
.baomingInfo h2{ height:84px; line-height:84px; font-size:24px;border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; text-align: center;}
.baomingInfo ul{margin:24px 5%; font-size:14px; overflow: hidden;}
.baomingInfo li{float: left; padding-right: 100px;}
.baomingInfo li span{color:#111; font-size: 16px;}
.baomingInfo .list{margin:0 3%}
.baomingInfo .item{ height:53px; line-height: 53px; text-align: center; }
.baomingInfo .item-th{color:#111;}
.baomingInfo .item-td{border-bottom:1px solid #e8e8e8;}
.baomingInfo .item-td:hover{background: #e6f7ff;}
.baomingInfo .list span{color:#9f9f9f;}
.baomingInfo .list .pay{color:#5db9ff; cursor: pointer;}
.baomingInfo p{text-align: center;}
.baomingInfo p img{padding-top:24px;}
.baomingInfo p span{display: block;padding:24px 0 34px;font-size: 16px;color: #a4a4a4;}
.baomingInfo .pagination{ margin-bottom:50px; margin-right: 3%;}
.baomingInfo .baoming-btn{ display: block;  width:44px; margin:0 auto 54px; height:32px; line-height:32px;text-align:center; font-size:16px;border:solid 1px #1890ff; background:#1890ff;color:#fff;border-radius: 5px; cursor: pointer; padding:0 15px; font-size:13px;}

.mbaomingInfo { margin:0.8rem 0;  background:#fff;overflow: hidden; font-size:1rem; }
.mbaomingInfo h2{height:5rem; line-height:5rem; font-size:1.4rem;  border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;  text-align: center; } 
.mbaomingInfo ul{ font-size:1.2rem; overflow: hidden; border-bottom:10px solid #f5f5f5; padding-left:5%; padding-top:1rem; padding-bottom:1rem; }
.mbaomingInfo li{ padding:0.5rem 0; }
.mbaomingInfo li.last{text-align: center; height:1.4rem; color:#0978e0;}
.mbaomingInfo li.last a{color:#0978e0; }

.mbaomingInfo p{text-align: center;}
.mbaomingInfo p img{padding-top:1.2rem;}
.mbaomingInfo p span{display:block;padding:1.2rem 0 1.6rem;font-size:1.3rem;color: #a4a4a4;}
.mbaomingInfo .pagination{ margin-bottom:50px; margin-right: 3%;}
.mbaomingInfo .baoming-btn{ display:block;width:40%; margin:0 auto 2.7rem; height:2.6rem; line-height:2.6rem;text-align:center;border:solid 1px #1890ff; background:#1890ff;color:#fff;border-radius:5px; cursor: pointer; padding:0 0.7rem; font-size:13px;}


</style>
<script>   
	import pay from "../components/pay" 
	export default {
		name: 'mySignUp',
		components: {pay:pay},
		methods: {
			init(){
				this.myInfo();
				this.list();
			},
			list(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("BaomingList?UserID="+userId+"&PageSize="+self.pageSize+"&PageIndex="+self.pageIndex,function(res){
                if(res.ReturnCode == 1){
					self.noticeArr=res.Result;
					if(self.noticeArr.length>0){
						//这一段是防止进入页面出去后再进来计时器重复启动
						if (self.ticker) {
							clearInterval(self.ticker);
						}
						
						self.beginTimer();
						self.hasData=true;
					}
					else
						self.hasData=false;
					self.totalCount=parseInt(res.Message);

                }else{
                    self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }	
                },function(err){
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
			},
			sysParam(){
				//得到缓存的时间
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("SysParam?UserID="+userId+"&ID=1",function(res){
                if(res.ReturnCode == 1){
					self.sepTime=parseInt(res.Result);
                }else{
                    self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }	
                },function(err){
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
			},
			baomingCancel(baomingId){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("BaomingCancel?UserID="+userId+"&BaomingID="+baomingId,function(res){
					self.list();
                },function(err){
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
			},
			countDown(seconds,index){
				//倒计时
				// var ss="已取消";
				// var createDate = new Date(date);   //创建时间
				// var nowDate = new Date(); 		   //获取当前时间
				// var endDate= new Date(createDate.setMinutes(createDate.getMinutes() + this.sepTime));
				// if(endDate>nowDate){
				// 	var lefttime = endDate.getTime() - nowDate.getTime();  //距离结束时间的毫秒数
				// 	var leftm = Math.floor(lefttime/(1000*60)%60);  	   //计算分钟数
				// 	if(leftm.toString().length==1)
				// 		leftm="0"+leftm;
				// 	var lefts = Math.floor(lefttime/1000%60);  //计算秒数
				// 	if(lefts.toString().length==1)
				// 		lefts="0"+lefts;
				// 	ss =  "待支付("+ leftm + ":" + lefts+")";  //返回倒计时的字符串 
				// }
				// return ss;


				var ss="已取消";
				
				if(seconds>0){
					var lefttime = seconds;  //距离结束时间的毫秒数
					var leftm = Math.floor(lefttime/(1000*60)%60);  	   //计算分钟数
					if(leftm.toString().length==1)
						leftm="0"+leftm;
					var lefts = Math.floor(lefttime/1000%60);  //计算秒数
					if(lefts.toString().length==1)
						lefts="0"+lefts;
					ss =  "待支付("+ leftm + ":" + lefts+")";  //返回倒计时的字符串 

					seconds=parseInt(seconds)-1000;
					this.noticeArr[index].Seconds=seconds;
				}
				return ss;

			},
			beginTimer() { //这个计时器是每秒减去数组中指定字段的时间
				// --10:时间在15分钟内，等待支付；时间过了15分钟，已取消
				// --11：支付成功，在线报名通过，去理论考试
				// --12：理论考试成功，去实操考试
				// --13：实操考试成功，去证书办理
				// --14：证书办理已完成
				var self=this;
				this.ticker = setInterval(() => {
					self.noticeArr.forEach(function (item, index) {
						if(item.Status==10){
							if(index==0){
								var r=self.countDown(item.Seconds,index);
								self.$set(item, 'limit_time', r);
								if(r=="已取消"){
									clearInterval(self.ticker);
								}
							}
							else{
								self.$set(item, 'limit_time', "已取消");
							}
						}else if(item.Status==11){
							// if(item.WrittenTestCount>0){
							// 	self.$set(item, 'limit_time', "理论考试");
							// }else{
							// 	self.$set(item, 'limit_time', "理论考试补考");
							// }
							if(self.realName=='')
								self.$set(item, 'limit_time', "实名认证");
							else
								self.$set(item, 'limit_time', "理论考试");
							
						}else if(item.Status==12){
							// if(item.OperationCount>0){
							// 	self.$set(item, 'limit_time', "实操考试");
							// }else{
							// 	self.$set(item, 'limit_time', "实操考试补考");
							// }
							self.$set(item, 'limit_time', "实操考试");
						}else if(item.Status==13){
							self.$set(item, 'limit_time', "证书办理");
						}else if(item.Status==14){
							self.$set(item, 'limit_time', "已完成");
						}else if(item.Status==15){
							self.$set(item, 'limit_time', "理论考试失败");
						}else if(item.Status==16){
							self.$set(item, 'limit_time', "实操考试失败");
						}
					});
				}, 1000);
			},
			handleCurrentChange(val){
				this.pageIndex=val;
			    this.list();
			},
			formatDate(date){
				return this.http.dateFormat1("yyyy-MM-dd hh:mm:ss",date);
			},
			showWindow(bal,id,gameId,title){
				this.bal=bal;
				this.id=id;
				this.gameId=gameId.toString();
				var arr=title.toString().split('-');
				this.levelGame=arr[1];
				this.isShowWindow=true;
			},
			closeWindow(val){
				this.isShowWindow=val;
			},
			reload(){
				this.isShowWindow=false;
				this.list();
			},
			checkStatus(limitTime){
				var str=0;
				if(limitTime){
					if(limitTime=="已取消")
						str=0;
					else if(limitTime.toString().indexOf('待支付')!=-1)
						str=1;
					else if(limitTime=="实名认证")
						str=8;
					else if(limitTime=="理论考试")
						str=2;
					else if(limitTime=="实操考试")
						str=3;
					else if(limitTime=="证书办理")
						str=4;
					else if(limitTime=="已完成")
						str=5;
					else if(limitTime=="理论考试失败")
						str=6;
					else if(limitTime=="实操考试失败")
						str=7;
				}
				return str;
			},
			myInfo(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.isShow=false;
				self.http.ajaxGet("GetMyIDCard?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						var arr=res.Result;
						if(arr.length==0){
							// self.$alert('请先完成实名认证', '', {
							// confirmButtonText: '实名认证',
							// type:"info",
							// showClose:false,
							// callback: action => {
							// 	self.$router.push({path:'/auth'});
							// }
							// });
							self.isShow=true;
							self.realName='';
							self.idcard='';
						}else{
							self.isShow=true;
							self.realName=arr[0].RealName;
							self.idcard=arr[0].IDCard;
						}
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}	
					},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			}
		},
		data() {
			return {
				pageIndex:1,
				totalCount:0,
				noticeArr:[],
				hasData:false,
				bal:280,
				id:0,
				isShowWindow:false,
				IsMySignUpPage:true,
				ticker:'',
				realName:'', 
				idcard:'',
				cardType:'',
				isShow:false,
				gameId:'',
				levelGame:''
			}
		},
		computed:{
			pageSize(){
				return this.$store.getters.pageSize;
      		},
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			//this.$store.dispatch('isShowWxActions',false);
			this.init();
		},
		beforeDestroy() {
			if(this.ticker) clearInterval(this.ticker);
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/my-sign-up.vue